enum CallCenterCurrentState {
    Idle = 0,
    Ringing = 1,
    InCall = 2,
    OnHold = 3
}

export { CallCenterCurrentState };
